<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>服务商服务过程管理【按门店类型】</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div name="table-list" class="table-layout" v-if="paramMap != null">
            <swb-easy-report-table :confKey="confKey" :configAuto="true" :reportName="reportName" :reportCode="reportCode" :paramMap="paramMap" :hideParamKeys="hideParamKeys" :metaColList="metaColList" :domHeight="domHeight"></swb-easy-report-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import easyReportApi from '../../api/easyReport'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'servicer-servc-process-for-shop-tag',
        path: '/servicer/servc/process/for/shop/tag',
        desc: '服务商服务过程管理【按门店类型】',
        helpArticleCode: 'retailer-servicer-servc-process-for-shop-tag',
        data: function () {
            return {
                confKey: 'servicer-servc-process-for-shop-tag',
                reportCode: "retailer_shop_tag_servicer_servc_process",
                reportName: '服务商服务过程管理【按门店类型】',
                //
                domHeight: 'auto',
                //
                paramMap: null,
                hideParamKeys: ["retailerId", "cxtMerchantId", "cxtMerchantIdX"],
                metaColList: []
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="table-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"]'));
            domSizeWatcher.start(500);
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            let paramMap = {
                retailerId: 259,
            };
            //
            this.paramMap = Utils.merge({}, paramMap);
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/ServicerServcProcessForShopTag.vue